export default __webpack_public_path__ + "static/media/item6.7e37429b.jpg";